import {
  AdvancedFilterDataSchema,
  FilterGroupSchema,
} from "@redotech/redo-model/views/views";
import * as z from "zod/v4";

const ProductImage_ = z.object({ url: z.string(), kind: z.string() });
export const ProductImage: z.ZodType<ProductImage> = ProductImage_;
export interface ProductImage extends z.infer<typeof ProductImage_> {}

const StationQueueItem_ = z.object({
  workOrderId: z.string(),
  flowId: z.string(),
  flowName: z.string().nullable(),
  currentStepId: z.string(),
  currentStepTitle: z.string().nullable(),
  status: z.string(),
  triggerKind: z.string(),
  bomName: z.string().nullable(),
  outputProductName: z.string().nullable(),
  externalOrderName: z.string().nullable(),
  quantity: z.number().int(),
  createdAt: z.date(),
  currentStepStartedAt: z.date().nullable(),
  productImages: z.array(ProductImage),
  toteName: z.string().nullable(),
});
export const StationQueueItem: z.ZodType<StationQueueItem> = StationQueueItem_;
export interface StationQueueItem extends z.infer<typeof StationQueueItem_> {}

export const getStationQueue = {
  name: "getStationQueue" as const,
  input: z.object({
    stationId: z.string().optional(),
    sort: z
      .object({ key: z.string(), direction: z.enum(["asc", "desc"]) })
      .optional(),
    search: z.string().nullish(),
    filterGroup: FilterGroupSchema.nullish(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).default([]),
  }),
  output: z.object({ items: z.array(StationQueueItem) }),
};
